import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import { Product } from '../../models/product.model'
import TransformerCard from './Transformer/TransformerCard'
import TransformerMoreInfoProduct from './Transformer/TransformerMoreInfoProduct'
import { makeStyles } from 'tss-react/mui'
import { useDispatch } from 'react-redux'
import { addSmartMeter, removeSmartMeter } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationAction'

interface SmartMeterModalProps {
  smartMeters: Product[]
  selectedSmartMeterId: string | null
  place: number
  onClose: () => void
}

const useStyles = makeStyles()(theme => ({
  cardWrapper: {
    marginTop: theme.spacing(2),
    display: 'grid',
    alignItems: 'strech',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: theme.spacing(4),
    gridAutoRows: '1fr',
    gridTemplateColumns: 'repeat(auto-fit, 270px)',
  },
}))

const SmartMeterModal: React.FC<SmartMeterModalProps> = ({ place, onClose, smartMeters, selectedSmartMeterId }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const [selectedProductId, setSelectedProductId] = useState<string | null>(selectedSmartMeterId)
  const [moreInfoProduct, setMoreInfoProduct] = useState<string | null>(null)
  const desiredProduct = smartMeters.find(product => product.id === moreInfoProduct) ?? null

  const modalActions = {
    primary: {
      name: t('shop.common.further'),
      onClick: () => {
        if (selectedProductId) {
          dispatch(addSmartMeter(selectedProductId))
          onClose()
          return
        }
        dispatch(removeSmartMeter())
        onClose()
      },
    },
    secondary: {
      name: t('shop.common.exit'),
      onClick: () => onClose(),
    },
  }

  const handleSelectedProduct = (productId: string | null): void => {
    setSelectedProductId(productId)
  }

  const handleMoreInfoProduct = (productId: string | null): void => {
    setMoreInfoProduct(productId)
  }

  return (
    <Dialog
      title={t('shop.transformer.add-smart-meter')}
      maxWidth={moreInfoProduct ? 'sm' : 'md'}
      onClose={onClose}
      place={place}
      actions={modalActions}
    >
      <Box>
        {moreInfoProduct === null ? (
          <Box className={classes.cardWrapper}>
            {smartMeters.map(smartMeter => {
              return (
                <TransformerCard
                  showPrice
                  key={smartMeter.id}
                  productData={smartMeter}
                  selectedProductId={selectedProductId}
                  onSelectedPrductIdChange={handleSelectedProduct}
                  onMoreInfoProduct={handleMoreInfoProduct}
                />
              )
            })}
          </Box>
        ) : (
          <Box>{desiredProduct && <TransformerMoreInfoProduct productData={desiredProduct} onMoreInfoProductChange={handleMoreInfoProduct} />}</Box>
        )}
      </Box>
    </Dialog>
  )
}

export default SmartMeterModal
